export const languages = [
  {
    value: "en",
    label: "English",
  },
  {
    value: "de",
    label: "German",
  },
  {
    value: "fr",
    label: "French",
  },
];

const localeMap: Record<string, string> = {
  EN: "en_US",
  DE: "de_DE",
  FR: "fr_FR",
};

export const toFullLocale = (shortCode: string): string =>
  localeMap[shortCode.toUpperCase()] || "en_US";
